/**
 * Random BULG Product Distribution
 *
 * Picks 8 unique products from hidden pools with color-family diversity,
 * then distributes them across all target section slots (no repeats).
 *
 * Color families (derived from product handles):
 *   green   — british-racing-green, esmeralda, heritage-green, hunter
 *   dark    — charcoal-white-berry, darkness, laden-grey
 *   warm    — bali-orange, anatolia, dormen
 *   blue    — dark-blue-bond
 *   gold    — summer-gold
 *   neutral — beige (bleched nature)
 *   multi   — cest-la-vie, ephesus, goshima, primavera, quamash, nr-788
 */
(function () {
  'use strict';

  /* ── helpers ─────────────────────────────────────────────── */

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  /**
   * Pick `count` cards from `cards`, maximising color-family spread.
   * Round-robins across shuffled families so no family dominates.
   */
  function pickDiverse(cards, count) {
    var families = {};
    cards.forEach(function (c) {
      var f = c.dataset.colorFamily || 'other';
      if (!families[f]) families[f] = [];
      families[f].push(c);
    });

    Object.keys(families).forEach(function (k) {
      shuffle(families[k]);
    });

    var keys = shuffle(Object.keys(families));
    var picked = [];
    var idx = 0;

    while (picked.length < count && keys.length > 0) {
      var key = keys[idx % keys.length];
      var bucket = families[key];
      if (bucket.length > 0) {
        picked.push(bucket.shift());
        idx++;
      } else {
        keys.splice(idx % keys.length, 1);
        if (keys.length === 0) break;
      }
    }
    return picked;
  }

  /* ── main ────────────────────────────────────────────────── */

  function distribute() {
    var pools = document.querySelectorAll('[data-random-pool]');
    if (!pools.length) return;

    // Collect all slot targets and their counts in document order
    var targets = [];
    var totalNeeded = 0;
    pools.forEach(function (pool) {
      var name = pool.dataset.randomPool;
      var count = parseInt(pool.dataset.randomCount, 10) || 3;
      var slots = document.querySelectorAll(
        '[data-random-slot="' + name + '"]'
      );
      count = Math.min(count, slots.length);
      targets.push({ name: name, count: count, slots: slots });
      totalNeeded += count;
    });

    // Use cards from the first pool (all pools render the same collection)
    var cards = Array.prototype.slice.call(
      pools[0].querySelectorAll('.bulg-random-card')
    );

    if (!cards.length) return;

    // Pick all needed products at once — no repeats across sections
    var selected = pickDiverse(cards, Math.min(totalNeeded, cards.length));

    // Distribute across targets in order
    var offset = 0;
    targets.forEach(function (t) {
      for (var i = 0; i < t.count && offset < selected.length; i++) {
        var card = selected[offset];
        card.style.display = '';
        t.slots[i].innerHTML = '';
        t.slots[i].appendChild(card);
        offset++;
      }
    });

    // Remove all pools
    pools.forEach(function (pool) {
      pool.remove();
    });
  }

  // Run as soon as DOM is interactive
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', distribute);
  } else {
    distribute();
  }
})();
